import axios from 'axios';

export const state = {
}

export const getters = {}

export const mutations = {
}

export const actions = {

  async fetchProducts({ commit, dispatch, getters }, pagination = {}) {

    try{

      const { page, rowsPerPage, sortBy, descending, filter, filterKey } = pagination;

      const listObject =  {
        where: null,
        search: null,
        strict: true,
        pagination: {
          page,
          rowsPerPage,
          sortBy,
          descending
        }
      };

      if(filter){
        listObject['search'] = {
          column: filterKey,
          value: filter
        }
      }

      const result = await axios.post('product/list', listObject);

      return { success: true, message: 'Products fetched successfully!', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async assignDiscount({ commit, dispatch, getters }, body = {}) {

    try{

      const result = await axios.put('product/discount', body);

      return { success: true, message: 'Products updated successfully!', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },
}